export enum SideMenuColorEnum {
    orange1 = '#FECBA1',
    lightBlue2 = '#FCE38A',
    lightGreen3 = '#DAE78D',
    darkGreen4 = '#A3CFBB',
    darkBlue5 = '#9EC5FE',
    purple6 = '#C29FFA',
    pink7 = '#EFADCE',
    purple8 = '#a6ffb8',
    lightGreen9 = '#d5caf7',


    orange11 = '#FECBA1',
    lightBlue12 = '#FCE38A',
    lightGreen13 = '#DAE78D',
    darkGreen14 = '#A3CFBB',
    darkBlue15 = '#9EC5FE',

    // lightGreen11 = '#DAE78D',
    // darkGreen12 = '#A3CFBB',
    // darkBlue13 = '#9EC5FE',
}